import type { ReactNode } from 'react'

type Column<T> = {
  key: string
  header: string
  mobileLabel?: string
  render: (row: T) => ReactNode
  hideOnMobile?: boolean
}

export function ResponsiveTable<T>({
  columns,
  rows,
  rowKey,
  empty,
}: {
  columns: Column<T>[]
  rows: T[]
  rowKey: (row: T, index: number) => string
  empty?: ReactNode
}) {
  if (rows.length === 0) {
    return <div className="pp-empty">{empty || 'No rows.'}</div>
  }

  return (
    <>
      <div className="pp-table-wrap pp-table-wrap--desktop">
        <table className="pp-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key}>{c.header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={rowKey(row, i)}>
                {columns.map((c) => (
                  <td key={c.key}>{c.render(row)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pp-card-stack pp-card-stack--mobile">
        {rows.map((row, i) => (
          <article key={rowKey(row, i)} className="pp-mobile-card">
            {columns
              .filter((c) => !c.hideOnMobile)
              .map((c) => (
                <div key={c.key} className="pp-mobile-card__row">
                  <span>{c.mobileLabel || c.header}</span>
                  <strong>{c.render(row)}</strong>
                </div>
              ))}
          </article>
        ))}
      </div>
    </>
  )
}
